/*
* Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
* This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
* The receipt or possession of this program does not convey any rights to use, reproduce or disclose
* its contents in whole or in part, without the specific written consent of Inovalon, Inc.
* Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
* is a violation of the copyright laws and may subject you to criminal prosecution.
*/
import React, { Fragment } from 'react'
import { CommonUtils } from '../../../../utils/CommonUtils'
import NumberFormat from 'react-number-format'
import { IInpatientTypeInsurance, ICoPay } from '../../../../services/CoverageDiscoveryResponseStateManager/contracts'

export interface ILifetimeReserveProps {
	data: IInpatientTypeInsurance
}

interface ILifetimeReserveState {
	collapse: number
}

export class LifetimeReserveComponent extends React.Component<ILifetimeReserveProps, ILifetimeReserveState> {
	render(): React.ReactNode {
		const lifetimeReserveModel = this.props.data

		if (lifetimeReserveModel) {
			if (lifetimeReserveModel.reserve && lifetimeReserveModel.reserve.lifetime > 0) {
				const getCopays = (copays: ICoPay[]): JSX.Element[] | undefined => {
					if (copays) {
						let first = true
						return copays.map((copay, index) => {
							return (
								<tr key={index}>
									<td>{first ? 'LTR Co-Pay:' : ''}</td>
									{(first = false)}
									<td colSpan={3}>
										{CommonUtils.DateRange(copay.startDate, copay.endDate, true)} @{' '}
										<strong>
											<NumberFormat value={copay.amount} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} prefix={'$'} renderText={(value: string): JSX.Element => <span>{value}</span>} />
										</strong>
										/{copay.periodDefinition}
									</td>
								</tr>
							)
						})
					}
				}
				return (
					<Fragment>
						<tr>
							<td>LTR:</td>
							<td colSpan={3}>
								<strong>{lifetimeReserveModel.reserve.remaining}</strong> {lifetimeReserveModel.reserve.quantityQualifier} Remain of <strong>${lifetimeReserveModel.reserve.lifetime}</strong> {lifetimeReserveModel.reserve.quantityQualifier} Total
							</td>
						</tr>
						{getCopays(lifetimeReserveModel.reserve.coPays)}
					</Fragment>
				)
			} else {
				return <></>
			}
		} else {
			return <></>
		}
	}
}
